class Slider {
  constructor() {
    // 1. Define properties on the class instance
    this.slides = document.querySelectorAll(".slide");
    this.dots = document.querySelectorAll(".dot");
    this.current = 0;

    // 2. Initialize setup if elements exist
    if (this.slides.length > 0) {
      this.init();
    }
  }

  // 3. Methods do not use the 'function' keyword
  showSlide(index) {
    this.slides.forEach(slide => slide.classList.remove("active"));
    this.dots.forEach(dot => dot.classList.remove("active"));

    this.slides[index].classList.add("active");
    if (this.dots[index]) {
      this.dots[index].classList.add("active");
    }
  }

  init() {
    // Arrow functions preserve the correct 'this' context
    document.querySelector(".next").addEventListener("click", () => {
      this.current = (this.current + 1) % this.slides.length;
      this.showSlide(this.current);
    });

    document.querySelector(".prev").addEventListener("click", () => {
      this.current = (this.current - 1 + this.slides.length) % this.slides.length;
      this.showSlide(this.current);
    });

    // Auto-play interval
    setInterval(() => {
      this.current = (this.current + 1) % this.slides.length;
      this.showSlide(this.current);
    }, 5000);
  }
}


export default Slider
